import { apiClient } from "./client";

export interface EmailTemplate {
  id: string;
  chiave: string;
  nome: string;
  oggetto: string;
  corpo_html: string;
  attivo: boolean;
  updated_at: string;
}

export async function listEmailTemplates(): Promise<{ templates: EmailTemplate[] }> {
  const { data } = await apiClient.get<{ templates: EmailTemplate[] }>("/email-templates");
  return data;
}

export async function updateEmailTemplate(
  chiave: string,
  payload: Partial<Pick<EmailTemplate, "oggetto" | "corpo_html" | "attivo">>
): Promise<{ template: EmailTemplate }> {
  const { data } = await apiClient.patch<{ template: EmailTemplate }>(`/email-templates/${chiave}`, payload);
  return data;
}

export interface EmailTemplatePreview {
  oggetto: string;
  corpo_html: string;
  variabili_esempio: Record<string, string>;
}

export async function previewEmailTemplate(
  chiave: string,
  oggetto: string,
  corpo_html: string
): Promise<EmailTemplatePreview> {
  const { data } = await apiClient.post<EmailTemplatePreview>(`/email-templates/${chiave}/preview`, {
    oggetto,
    corpo_html,
  });
  return data;
}
